// ============================================================
// プレイヤーアバター（マイページ・アバターメニュー・フレンド対戦の対戦相手で使用）
//
// avatarUrl があれば img、無ければ頭文字（プレイヤー名の最初1文字）の円形フォールバック。
// イベント画面では使用しない（既存の色付き番号サークルを継続）。
// ============================================================

interface Props {
  name:            string
  avatarUrl:       string | null
  avatarUpdatedAt: string | null
  size?:           number
  /** 追加の className（外側 span に付与） */
  className?:      string
}

export default function PlayerAvatar({
  name, avatarUrl, avatarUpdatedAt, size = 32, className,
}: Props) {
  const initial = (name ?? '').slice(0, 1) || '?'
  const cacheBuster = avatarUpdatedAt
    ? `?v=${encodeURIComponent(avatarUpdatedAt)}`
    : ''
  const src = avatarUrl ? `${avatarUrl}${cacheBuster}` : null
  return (
    <span
      className={[
        'inline-flex items-center justify-center rounded-full overflow-hidden bg-primary text-white font-bold leading-none shrink-0',
        className ?? '',
      ].join(' ')}
      style={{
        width: size,
        height: size,
        fontSize: Math.max(10, Math.round(size * 0.45)),
      }}
    >
      {src ? (
        <img src={src} alt="" className="w-full h-full object-cover" draggable={false} />
      ) : (
        initial
      )}
    </span>
  )
}
